import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const SlideFullImageHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);
  const subButtonFontURL = getFontURL(btnFontFamily?.sub_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  const blackImageUrl = 'https://i.ibb.co/ZX7zDn1/Frame-101.png';
  const plusImageUrl = 'https://i.ibb.co/qMpSJ4w/Group-20.png';

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonFontURL});
  }
  @font-face {
    font-family: 'subButton';
    src: url(${subButtonFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;      
    }    
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
  
      overflow: hidden;
      position: relative;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };
  
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

   

    .center_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 20px;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 100%;
      position: relative;    
    }
    .slick-track {
      display: flex;
      align-items: center;          
    }

    .slick_wrapper .slick-track {
      gap: 35px;
    }
    .slick_wrapper .slick-list {
      padding: 0 -0.3rem;         
    }
  
   
    .slider_image_box {
      width: 250px;
      height: 333px;
      outline: none;
      transition: all ease 0.3s 0s;      
      overflow: hidden;
    }

    .slider_image_box img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: ${radius?.multi_image}px;
      outline: none;
    }   

    .plus_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${plusImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      border-radius: 50%;
      background-color: transparent;
    }

    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      background: transparent;
    }
    .contents_wrapper {
      width: 100%;
      height: 140px;
      padding: 0 10%;
    }

    .contents_box .title {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      height: auto;
      max-height: 52px;
      line-height: 110%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      max-height: 56px;
      display: flex;
      align-items: center;
    }
    .contents_box .sub_title .sub_title_inner {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .bottom_wrapper {
      width: 100%;
      padding: 0 10%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .bottom_wrapper button {
      width: 100%;
      height: 48px;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily?.multi_button
          : 'multiButton'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }
    .close_btn {
      height: 20px

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;
      font-family: ${btnFontFamily?.multi_button};
      font-size: 16px;
            
      letter-spacing: 0.0225rem;
      margin-top: 16px;
    }
      
    @media screen and (max-height: 640px) {      
      .center_wrapper {
        gap: 16px;
      }
     
      .contents_wrapper {
        width: 100%;
        height: 112px;
        padding: 0 10%;
      }

      .contents_box .title {
        height: 64px;
        font-size: ${fontSize?.multi_title - 0.25}rem;
      } 
      .contents_box .sub_title {
        height: 48px;
      }      

      .bottom_wrapper button {
        height: 48px;
        font-size: ${btnFontSize?.multi_button - 0.125}rem;
      }
      
    }
    

    /*
		@media screen and (min-width: 600px) and (max-width: 1024px) {
      .close_btn {
        height: 2rem;
        top: 10%;
        right: 25%;
      }
      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        height: 38rem;
      }
      .slick_wrapper .slick-list {
        padding: 0 -1rem;
      }
      .slick_wrapper .slick-slide {
        padding: 0 1rem;
      }
      .slider_image_box {
        max-width: calc(22.8125rem * 0.8);
        height: calc(38rem * 0.8);
        // margin-top: 3.5rem;
      }
      .slider_image_box {
        max-width: 22.8125rem;
        height: 38rem;
        outline: none;
      }

      .contents_box .title {
        height: 6rem;
        font-size: ${fontSize?.multi_title + 0.25}rem;
      } 
      .title .title_inner {
        max-height: 4rem;
      }
      .contents_box .sub_title {
        height: 4rem;
        font-size: ${fontSize?.multi_sub_title + 0.25}rem;
      }      

      .contents_wrapper,
      .bottom_wrapper {
        padding: 0 25%;
      }
      .bottom_wrapper button {
        height: 4rem;
        font-size: ${btnFontSize?.multi_button + 0.5}rem;
      }
    }
    */
  `;

  const html = `
    <div class="root" id="test">    
      <div class="center_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `
              <div class="slider_image_box">
                <img 
                  class="image" 
                  src="${!data || data === '' ? blackImageUrl : data}" 
                  alt="" />
              </div>
              `
            )
            .join('')}
          </div>
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">${text?.multi_title
            ?.map(
              (_: any, idx: number) => `<div class="contents_box">
            <div class="title">
              <p class="title_inner">${changeEnterHTML(
                text?.multi_title?.[idx]
              )}</p>
            </div>
            <div class="sub_title">
              <p class="sub_title_inner">
               ${changeEnterHTML(text?.multi_sub_title?.[idx])}
              </p>
            </div>
          </div>`
            )
            .join('')}
          </div>
        </div>
        <div class="bottom_wrapper">
          <button class="bottom">
            ${btnText?.multi_button}
          </button>
          <div class="close_btn">${btnText?.sub_button}</div>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = '[';
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_button?.length; i++) {
    button_list += `'${btnText?.multi_button?.[i]}'`;
    if (i !== btnText?.multi_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_button?.[i]}', '${tracking?.multi_sub_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'SLIDE FULL IMAGE',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.slick_slider').slick({
      arrows: false,
      dots: false,
      infinite: false,
  
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 0,
      variableWidth: true,
      speed: 300,
      touchThreshold: 300
    });
  
    $('.contents_slider').slick({
      arrows: false,
      dots: false,
      fade: true,
  
      speed: 300,
      swipe: false
    });

    let currentIndex = 0;
    let button = ${button_list};
    $('.bottom').text(button[currentIndex]);
    $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.slick_slider').slick('slickCurrentSlide');
      $('.contents_slider').slick('goTo', currentIndex);
      $('.bottom').text(button[currentIndex]);
    });

    let deeplink = ${deeplink_list};
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.image').click(function() {
      appboyBridge.logClick(tracking[currentIndex][0]);
      try {
        if (button1[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.bottom').click(function() {
      appboyBridge.logClick(tracking[currentIndex][1]);
      try {
        if (button1[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.close_btn').click(function() {
      appboyBridge.logClick(tracking[currentIndex][2]);
      try {
        if (button1[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js" />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default SlideFullImageHTML;
